import ConfigFromEnv from '@stencil/config-from-env';
export const getOffersApiConfig = {
  mode: 'app',
  version: 'v1',
};

export const topDestinationsApiConfig = {
  version: 'v1',
};

export const brandPromisesApiConfig = {
  version: 'v1',
};

export const descblockApiConfig = {
  mobileFlavour: 'mobile',
};

export const smartEngageApiConfigForMweb = {
  flavour: 'mobile',
  landingType: {
    home: {
      context: 'hotels_home',
      slots: ['app_safety_card', 'app_prod_context'],
    },
    srp: {
      context: 'hotels_srp',
      slots: ['app_safety_header', 'app_test', 'hotel_srp_slot0'],
    },
    details: {
      context: 'hotels_home',
      slots: ['app_safety_card'],
    },
  },
};

export const smartEngageApiConfig = {
  version: 'v1',
  status: 'LIVE',
  homePageLanding: {
    context: 'hotels_home',
    slots: ['dwebHotels_info_home', 'dwebHotels_banner_home'],
    sendNodeId: true,
  },
  homePageLandingWithCityId: {
    context: 'hotels_home',
    slots: ['dwebHotels_info_home', 'dwebHotels_banner_home'],
    sendNodeId: true,
  },
  srpLanding: {
    context: 'hotels_srp',
    slots: ['dwebHotels_info_srp', 'dwebHotels_banner_srp'],
    sendNodeId: false,
  },
  detailsLanding: {
    context: 'hotels_home',
    slots: ['dwebHotels_info_details'],
    sendNodeId: true,
  },
};

export const hermesSrpApiConfig = {
  version: 'v12',
};

export const hermesSrpOfferApiConfig = {
  version: 'v11.5',
};

export const hermesReviewOffersApiConfig = {
  version: 'v11.5',
};

export const detailsHermesConfig = {
  version: 'v12',
};

export const hermesSegmentSliderApiConfig = {
  version: 'v12',
};

export const hermesDealsPageApiConfig = {
  version: 'v11',
};

// change this back before deployment
export const __HERMES__ = ConfigFromEnv('__HERMES__');
export const __VOYAGER__ = ConfigFromEnv('__VOYAGER__');
export const __VOYAGERX__ = ConfigFromEnv('__VOYAGERX__');

export const __GOIBIBO__ = ConfigFromEnv('__GOIBIBO__');
export const __DEXTER__ = ConfigFromEnv('__DEXTER__');
export const __UGC__ = ConfigFromEnv('__UGC__');

export const __latLongToVcid__ = '/api/v1/hotels/nearby_hotel_city/';

export const detailsAPIEndPoints = {
  hermes: `hotels/${detailsHermesConfig.version}/detail/price/v3`,
  cancellationPolicy: `hotels/getCancelPolicyDataNew`,
  hotelPolicy: `hotels/getHotelPolicyDataV2/?flavour=v3&tag=All`,
  similarHotels({
    cityId,
    checkin,
    checkout,
    hyphenatedPax,
    queryString,
    flavor,
  }: {
    cityId: string;
    checkin: string;
    checkout: string;
    hyphenatedPax: string;
    queryString: string;
    flavor: 'v3' | 'mobile';
  }) {
    return `${__HERMES__}/hotels/v12/suggest/data/${flavor}/${cityId}/${checkin}/${checkout}/${hyphenatedPax}/${queryString}`;
  },
};

export const noCostEMIMarketingLink = 'https://www.goibibo.com/offers/no-cost-emi/';
export const mwebPaymentCssCDN = 'https://goibibo.ibcdn.com/s3/avatar-mweb/css/payment.css';
